import _sequence from './_sequence.js';

const sequence = () => _sequence(1n);
export default sequence;
